import type { JSX } from 'ps-components';
import { defineCustomElements } from 'ps-components/loader';

import { createReactComponent } from 'enrollment/components/StencilWrappers/react-component-lib';

defineCustomElements(window);

export const PsButtonTuner = /*@__PURE__*/ createReactComponent<
  JSX.PsButtonTuner,
  HTMLPsButtonTunerElement
>('ps-button-tuner');
export const PsCheckboxTuner = /*@__PURE__*/ createReactComponent<
  JSX.PsCheckboxTuner,
  HTMLPsCheckboxTunerElement
>('ps-checkbox-tuner');
export const PsDrawerDialog = /*@__PURE__*/ createReactComponent<
  JSX.PsDrawerDialog,
  HTMLPsDrawerDialogElement
>('ps-drawer-dialog');
export const PsSelectTuner = /*@__PURE__*/ createReactComponent<
  JSX.PsSelectTuner,
  HTMLPsSelectTunerElement
>('ps-select-tuner');
export const PsSwitchTuner = /*@__PURE__*/createReactComponent<
  JSX.PsSwitchTuner, HTMLPsSwitchTunerElement
>('ps-switch-tuner');
export const PsTextTuner = /*@__PURE__*/ createReactComponent<
  JSX.PsTextTuner,
  HTMLPsTextTunerElement
>('ps-text-tuner');
export const PsModalTuner = /*@__PURE__*/ createReactComponent<
  JSX.PsModalTuner,
  HTMLPsModalTunerElement
>('ps-modal-tuner');
export const PsNumericTuner = /*@__PURE__*/ createReactComponent<
  JSX.PsNumericTuner,
  HTMLPsNumericTunerElement
>('ps-numeric-tuner');
export const PsRadioTuner = /*@__PURE__*/ createReactComponent<
  JSX.PsRadioTuner,
  HTMLPsRadioTunerElement
>('ps-radio-tuner');
export const PsDropdown = /*@__PURE__*/ createReactComponent<
  JSX.PsDropdown,
  HTMLPsDropdownElement
>('ps-dropdown');
export const PsAccordion = /*@__PURE__*/ createReactComponent<
  JSX.PsAccordion,
  HTMLPsAccordionElement
>('ps-accordion');
export const PsAccordionTuner = /*@__PURE__*/createReactComponent<
  JSX.PsAccordionTuner,
  HTMLPsAccordionTunerElement
>('ps-accordion-tuner');
export const PsAccordionChild = /*@__PURE__*/createReactComponent<
  JSX.PsAccordionChild,
  HTMLPsAccordionChildElement
>('ps-accordion-child');
export const PsCollapse = /*@__PURE__*/createReactComponent<
  JSX.PsCollapse,
  HTMLPsCollapseElement
>('ps-collapse');
export const PsTextareaTuner = /*@__PURE__*/createReactComponent<
  JSX.PsTextareaTuner,
  HTMLPsTextareaTunerElement
>('ps-textarea-tuner');
export const PsToastTuner = /*@__PURE__*/createReactComponent<
  JSX.PsToastTuner, HTMLPsToastTunerElement
>('ps-toast-tuner');
export const PsToastDialog = /*@__PURE__*/createReactComponent<
  JSX.PsToastDialog, HTMLPsToastDialogElement
>('ps-toast-dialog');

export { createReactComponent, JSX };
